function dropDownShow(button) {
	button.parentElement.classList.add('-active');
	button.setAttribute('aria-expanded', 'true');
}
function dropDownHide(button) {
	button.parentElement.classList.remove('-active');
	button.setAttribute('aria-expanded', 'false');
}

function dropDown(event) {
	var state = event.currentTarget.getAttribute('aria-expanded');
	if (state === 'true') {
		dropDownHide(event.currentTarget);
	} else {
		dropDownShow(event.currentTarget);
	}
}

function ready() {
	window.removeEventListener('load', ready);
	document.addEventListener('DOMContentLoaded', ready);

	var query = window.matchMedia('(min-width: 1024px)');
	var buttons = document.querySelectorAll('.page-header__drop-parent > button');

	Array.prototype.forEach.call(buttons, function (button) {

		var dropId = button.getAttribute('aria-controls');
		var dropMenu = document.getElementById(dropId);

		button.addEventListener('click', dropDown);

		button.addEventListener('mouseenter', function (event) {
			if (!query.matches) {
				return;
			}
			dropDownShow(event.currentTarget);
		});

		dropMenu.addEventListener('mouseleave', function (event) {
			if (!query.matches) {
				return;
			}
			dropDownHide(button);
		});
	});
}

if (document.readyState.match(/(completed|interactive)/i)) {
	ready();
} else {
	window.addEventListener('load', ready);
	document.addEventListener('DOMContentLoaded', ready);
}
